<template>
  <div class="header-prop">
    <div class="container">

      <div class="columns is-gapless is-flex-mobile is-centered">
        <div class="column is-6 is-11-mobile has-text-centered">

          <div class="cont-desc" data-aos="fade-up" data-aos-once="true">
            <h1 class="supertitle">{{ title }}</h1>
            <h2>{{ subtitle }}</h2>
          </div>

          <div class="cont-desc" data-aos="fade-up" data-aos-once="true">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import _ from 'lodash'
  export default {
    name: 'header-prop',
    props: [
      'title',
      'subtitle'
    ],
    data () {
      return {
      }
    },
    mounted () {
    }
  }
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.header-prop {
  width: 100%;

  .container {
    background-color: gray;

    .cont-desc {
      margin-bottom: 4em;
    }
  }
}

</style>



// WEBPACK FOOTER //
// HeaderProp.vue?36259e98